import { preloadImage } from '@fc/utilities';

const MARKET_CONTEXT_QUERY_KEYS = ['country', 'locale'];

export function preserveMarketContext(url) {
  const current = new URL(window.location.href);

  for (const key of MARKET_CONTEXT_QUERY_KEYS) {
    const value = current.searchParams.get(key);
    if (value && !url.searchParams.has(key)) {
      url.searchParams.set(key, value);
    }
  }

  return url;
}

export function parsePositiveInt(value) {
  const number = Number.parseInt(String(value ?? ''), 10);
  return Number.isFinite(number) && number > 0 ? number : 0;
}

function urlPath(value) {
  if (!value) return '';

  try {
    return new URL(value, window.location.origin).pathname;
  } catch {
    return String(value).split('?')[0] || '';
  }
}

export function sameProductPath(first, second) {
  const firstPath = urlPath(first);
  const secondPath = urlPath(second);
  return Boolean(firstPath && secondPath && firstPath === secondPath);
}

function cardImageSource(doc) {
  const img = doc?.querySelector?.('[data-ref="cardGalleryLink"] img, .product-media-container img');
  if (!(img instanceof HTMLImageElement)) return '';

  return img.getAttribute('src') || img.currentSrc || img.src || '';
}

export function preloadCardImage(doc) {
  const src = cardImageSource(doc);
  if (src) preloadImage(src);
}
